<template>
  <v-col style="min-width: 326px" class="test">
    <!-- <img v-bind:src="data.img" class="Foto-User mx-auto" /> -->
    <v-avatar color="white" size="100" class="Foto-User">
      <v-avatar color="#F1F1F1" size="95" class="Foto-User-Inside">
        <v-img v-if="data.img" :src="data.img" />
        <span v-else class="white--text Foto-User-Content">
          <span class="firstWord" v-if="splitName(data.name)[0]">{{
            getFirstChar(splitName(data.name)[0])
          }}</span>
          <span class="secondWord" v-if="splitName(data.name)[1]">{{
            getFirstChar(splitName(data.name)[1])
          }}</span>
        </span>
      </v-avatar>
    </v-avatar>
    <p class="Coment">
      {{ data.desc }}
    </p>
    <v-row style="margin-left: 2px">
      <p class="Nama-User">
        {{ data.name }}
      </p>
      <p class="Pekerjaan">
        {{ data.job }}
      </p>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: "ContentTesti",
  props: ["data"],
  methods: {
    splitName(str) {
      return str.split(" ");
    },
    getFirstChar(splitStr) {
      return splitStr.charAt(0);
    },
  },
};
</script>

<style>
.Nama-User {
  height: 22px;
  flex-grow: 0;
  margin: 20px 12px 0 0;
  font-family: Inter;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.47;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
  max-width: "100%";
}
.Foto-User {
  display: block;
  margin-left: auto;
  margin-right: auto;
  filter: drop-shadow(0 0 0.75rem rgba(0, 0, 0, 0.08));
}
.Foto-User-Inside {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2px;
}
.firstWord {
  color: #d3352c;
}
.secondWord {
  color: #252525;
}
.Foto-User-Content {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 35%;
  font-family: Sora;
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 30px;
  text-align: center;
}
.Pekerjaan {
  height: 22px;
  flex-grow: 0;
  margin: 20px 0 0 21px;
  font-family: Inter;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.47;
  letter-spacing: normal;
  text-align: left;
  color: #b5b5b5;
  max-width: "100%";
}
.Coment {
  flex-grow: 0;
  margin: 32px 0 20px;
  font-family: Inter;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.47;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
@keyframes slide {
  from {
    right: 100px;
  }
  to {
    right: 0px;
  }
}
</style>
